import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import barChart from "./components//barChart";
import moment from 'moment';
export default {
  name: 'HitchStatList',
  mixins: [JeecgListMixin],
  components: {
    barChart: barChart
  },
  props: {
    width: {
      type: String,
      default: '100vw'
    },
    height: {
      type: String,
      default: '590px'
    }
  },
  data: function data() {
    return {
      pagePath: '/inspection/find/year/report',
      pageTitle: 'VIEW',
      pageChartTitle: '巡检情况统计',
      queryParam: {},
      // 表头
      columns: [],
      siteTree: [],
      value: [],
      mode2: ['month', 'month'],
      xData: [],
      autoLoadInit: false
    };
  },
  created: function created() {
    this.getSiteTree();
    this.limitSelectDate = {
      min: moment().subtract(6, 'months'),
      max: moment(moment().format('YYYY-MM'))
    };
    this.value = [this.limitSelectDate.min, this.limitSelectDate.max];
    this.queryParam.sdateBack = this.limitSelectDate.min.format('YYYY-MM');
    this.queryParam.edateBack = this.limitSelectDate.max.format('YYYY-MM');
    this.callback();
    this.initTableData();
  },
  mounted: function mounted() {},
  computed: {},
  methods: {
    moment: moment,
    initTableData: function initTableData(arg) {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      params.size = 9;
      params.pageSize = -1;
      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      var siteId = '';

      if (this.queryParam.siteId) {
        this.queryParam.siteId.forEach(function (item, index) {
          if (index == 0) {
            siteId = item;
          } else {
            siteId = siteId + ',' + item;
          }
        });
      }

      params.siteIds = siteId;
      delete params.siteId;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
          _this.columns = [];
          _this.xData = [];

          for (var item in _this.dataSource[0]) {
            var title = void 0;

            if (item == 'siteName') {
              title = '站点名称';
            } else if (item == 'totalCount') {
              title = '总数';
            } else {
              title = item;
            }

            _this.columns.push({
              dataIndex: item,
              colName: item,
              title: title,
              align: 'center'
            });

            if (item != 'siteName' && item != 'totalCount') {
              _this.xData.push(item);
            }
          }

          _this.queryChartData();
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    searchReset: function searchReset() {
      this.queryParam.siteId = '';
      this.searchQuery();
    },
    getSiteTree: function getSiteTree() {
      var _this2 = this;

      getAction('/online/env/api/queryTreeList?addrType=1').then(function (res) {
        if (res.success) {
          _this2.reviseTree(res.result);

          _this2.siteTree = res.result;
        }
      });
    },
    reviseTree: function reviseTree(tree) {
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];

        if (node.children) {
          node['disabled'] = true;
          this.reviseTree(node.children);
        } else {
          node['disabled'] = false;
        }
      }
    },
    callback: function callback(key) {},
    // 柱状图数据
    queryChartData: function queryChartData() {
      var _this3 = this;

      var data = {
        xData: this.xData,
        yData: [{
          type: 'value'
        }]
      };
      var columnsData = [];
      this.dataSource.forEach(function (item, index) {
        columnsData.push({
          title: item.siteName,
          data: []
        });

        _this3.xData.forEach(function (item1) {
          columnsData[index][item1] = item[item1];
        });
      });
      this.columns.forEach(function (item1) {
        columnsData.forEach(function (item2) {
          if (item1.dataIndex != 'siteName' && item1.dataIndex != 'totalCount') {
            item2.data.push(item2[item1.dataIndex]);
          }
        });
      });
      setTimeout(function () {
        console.log('data', data);
        console.log('columnsData', columnsData);

        _this3.$refs.chart.initBarChart(data, columnsData, _this3.pageChartTitle);
      }, 1000);
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.sdateBack = dateString[0];
      this.queryParam.edateBack = dateString[1];
    },
    handlePanelChange: function handlePanelChange(value, mode) {
      this.value = value;
      this.queryParam.sdateBack = value[0].format('YYYY-MM');
      this.queryParam.edateBack = value[1].format('YYYY-MM');
    }
  }
};